import React from "react";
import {Button} from "antd";
import {Form} from "react-final-form";

import {FormFieldType, FormField} from "../../../Components";
import {i18, trb, required, translationGroups} from "../../../Utilities";
import {LOGIN_TYPES} from "../../../Config";

const LOGIN_OPTIONS = [
    {
        value: LOGIN_TYPES.MOBILE,
        label: "AuthTypeMobile"
    },
    {
        value: LOGIN_TYPES.SMART_ID,
        label: "AuthTypeSmartId"
    },
    {
        value: LOGIN_TYPES.BIO_FACE,
        label: "AuthTypeBioFace"
    }
];

const parsePhone = value => {
    if (!value) return value;
    const onlyNums = value.replace(/[^\d]/g, "");
    return `+${onlyNums}`;
};

export const LoginForm = React.memo(({onSubmit, isSubmitting, submitting}) => {
    return (
        <Form
            onSubmit={values => onSubmit(values)}
            initialValues={{
                authType: "Mobile"
            }}
            render={({handleSubmit}) => {
                return (
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <FormField
                            name="authType"
                            component={FormFieldType.radio}
                            size="small"
                            options={LOGIN_OPTIONS}
                            validate={required}
                            optionsLabel="label"
                            optionsValue="value"
                            translate={translationGroups.Labels}
                            buttons
                            disabled={submitting}
                        />
                        <FormField
                            title={i18.Labels.Phone}
                            name="phone"
                            component={FormFieldType.input}
                            inputType="tel"
                            validate={required}
                            size="large"
                            parse={parsePhone}
                            disabled={submitting}
                        />
                        <FormField
                            title={i18.Labels.PersonCode}
                            name="personCode"
                            component={FormFieldType.input}
                            validate={required}
                            size="large"
                            disabled={submitting}
                        />
                        <div className="text-right">
                            <Button
                                type="primary"
                                htmlType="submit"
                                size="large"
                                loading={isSubmitting || submitting}
                                disabled={isSubmitting}
                            >
                                {trb(i18.Buttons.SignIn)}
                            </Button>
                        </div>
                    </form>
                );
            }}
        />
    );
});
